/**
 * Skills Engine entry point — one deterministic call that turns evidence
 * plus living signals into the sealed computation the UI renders verbatim.
 */

import { inferSkills } from "./infer";
import { computeFutureProbability } from "./probability";
import { SKILLS_ENGINE_VERSION, SKILLS_TAXONOMY_VERSION } from "./version";
import type { EvidenceRecord, LivingSignals, SkillsComputation } from "./types";

export function computeSkills(
  records: EvidenceRecord[],
  signals: LivingSignals = {},
  computed_at: string = new Date().toISOString(),
): SkillsComputation {
  const skills = inferSkills(records);
  return {
    engine_version: SKILLS_ENGINE_VERSION,
    taxonomy_version: SKILLS_TAXONOMY_VERSION,
    skills,
    indicators: computeFutureProbability(skills, signals),
    computed_at,
  };
}

/** Coverage of the 40-item bank, for the "keep going" nudge. */
export function evidenceCoverage(records: EvidenceRecord[], bankSize: number): number {
  const answered = new Set(records.filter((r) => r.option_ids.length > 0).map((r) => r.item_id));
  return bankSize === 0 ? 0 : Math.round((answered.size / bankSize) * 100) / 100;
}
